import { Component, OnInit, Input } from '@angular/core';
import { HtmlParser } from '@angular/compiler';

@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
    standalone: false
})
export class CardComponent implements OnInit {

  @Input() cardAriaLabel: string;
  @Input() cardTitle: HtmlParser;
  @Input() cardHelp: HtmlParser;

  constructor() { }

  ngOnInit() { }

}
